module.exports = __webpack_public_path__ + "img/img41.d77e3e35.svg";